module.exports = __webpack_public_path__ + "static/media/BecomeAbaronDollarSign.c95d9b8a.PNG";